import { getTheme, IStyle, mergeStyleSets } from "@fluentui/react";
import { BwjPalette } from "../../../app-theme";

export const usePRIVATE_STYLES = () => {
  const theme = getTheme();

  const header: IStyle = {
    padding: 0,
    paddingTop: 30,
    paddingLeft: 20,
  };

  const upperContent: IStyle = {
    display: 'flex',
    flexDirection: 'row',
  };

  const title: IStyle = {
    margin: 0,
    padding: 0,
    paddingRight: 20,
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
    alignItems: 'baseline',
    gap: 10,
  };

  const panelControl: IStyle = {
    display: 'none',
    '@media(min-width: 501px)': {
      display: 'block',
    }
  };

  const mobilePanelControl: IStyle = {
    display: 'none',
    '@media(max-width: 500px)': {
      display: 'block',
    }
  };

  const desktopOnlyAction: IStyle = {
    display: 'none',
    '@media(min-width: 501px)': {
      display: 'block',
    }
  };
  const mobileOnlyAction: IStyle = {
    display: 'none',
    '@media(max-width: 500px)': {
      display: 'block',
    }
  };

  const lowerContent: IStyle = {
    marginTop: 20,
    marginRight: 20,
    minHeight: 40,
    display: 'flex',
    flexDirection: 'row',
    flexFlow: 'wrap',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.neutralTertiary}`,
  };

  const durationTray: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  }

  const durationLabel: IStyle = {
    fontWeight: 500,
  };

  const fixedDurationValue: IStyle = {
    fontWeight: 500,
    display: 'block',
    paddingRight: 15,
  };

  const durationControlContainer: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  };

  const warningIcon: IStyle = {
    color: BwjPalette.themeWarning,
    fontSize: '1.2em',
    display: 'block',
    paddingRight: 5,
  };

  const actionButtonTray: IStyle = {
    margin: 0,
    marginLeft: 20,
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  };

  return mergeStyleSets({
    header,
    upperContent,
    title,
    panelControl,
    mobilePanelControl,
    lowerContent,
    durationTray,
    durationLabel,
    fixedDurationValue,
    durationControlContainer,
    warningIcon,
    actionButtonTray,
    desktopOnlyAction,
    mobileOnlyAction,
  });
}
